import React from "react"

function IconChatPause({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="chat-pause"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-chat-pause"
      {...props}
    >
      <path
        d="M20.183 3.436c.825 0 1.504.63 1.58 1.436l.008.153v17.18c0 .57-.666.853-1.075.503l-.074-.073-3.056-3.52H3.934a1.59 1.59 0 0 1-1.56-1.289l-.021-.149-.008-.153v-12.5c0-.824.631-1.503 1.436-1.58l.153-.008h16.249zm0 1.31H3.933a.28.28 0 0 0-.271.215l-.008.064v12.5c0 .133.093.244.216.273l.064.008h13.93c.152 0 .298.052.414.147l.08.078 2.103 2.42.001-15.426a.28.28 0 0 0-.146-.245l-.07-.027-.063-.008zM10.624 7.5c.56 0 1.022.422 1.085.965l.008.128v5.765c0 .56-.422 1.022-.966 1.086l-.127.007H9.03c-.56 0-1.023-.422-1.086-.965l-.007-.128V8.593c0-.56.422-1.022.965-1.085L9.03 7.5h1.595zm4.58 0c.561 0 1.023.422 1.086.965l.007.128v5.765c0 .56-.422 1.022-.965 1.086l-.127.007h-1.596c-.56 0-1.022-.422-1.085-.965l-.007-.128V8.593c0-.56.421-1.022.965-1.085l.127-.008h1.596zm-4.579 1.092H9.027v5.767l1.597.001.001-5.768zm4.58 0h-1.597l.001 5.768h1.596l.001-.002V8.592z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChatPause
